import React from 'react';

import t from '../../../labels/labelling-utils';
import { PlayerChart, PlayerCharts, PlayerStatistic, StatisticsType } from '../../../typings/player-statistics';
import PlayerCardStat, { IPlayerCardStat, IconType } from '../../molecules/player-card-stat/player-card-stat';
import PlayerCardsChart, { IPlayerCardsChart } from '../../organisms/player-cards-chart/player-cards-chart';

const buildChart = (item: PlayerCharts): JSX.Element => {
  const props: IPlayerCardsChart = {
    cardsChart: item.charts.map((chart: PlayerChart) => ({
      // @ts-ignore
      title: t(`player.chart.${chart.id.toLowerCase()}`),
      success: {
        // @ts-ignore
        text: t(`player.chart.${chart.id.toLowerCase()}.success`),
        value: chart.success,
      },
      failure: {
        // @ts-ignore
        text: t(`player.chart.${chart.id.toLowerCase()}.failure`),
        value: chart.failure,
      },
    })),
  };

  return <PlayerCardsChart {...props} />;
};

const getIcon = (type: StatisticsType): IconType | undefined => {
  switch (type) {
    case 'YellowCards':
      return 'yellow-card';
    case 'TotalRedCards':
      return 'red-card';
    default:
      return undefined;
  }
};

const buildStat = (item: PlayerStatistic): JSX.Element => {
  const props: IPlayerCardStat = {
    // @ts-ignore
    title: t(`player.statistics.${item.id.toLowerCase()}`),
    value: item.value,
    rightValue: item.unit,
    iconType: getIcon(item.id),
  };

  return <PlayerCardStat {...props} />;
};

export const buildStats = (items: (PlayerStatistic | PlayerCharts)[], cn: any): JSX.Element[] =>
  items.map((item, index) => {
    switch (item.type) {
      case 'chart':
        return (
          <div key={index} className={cn.stat}>
            {buildChart(item)}
          </div>
        );
      default:
        return (
          <div key={index} className={cn.stat}>
            {buildStat(item)}
          </div>
        );
    }
  });
